import React from "react";
import {
  Ship,
  Package,
  Truck,
  HardHat,
  Globe2,
  Laptop,
  Anchor,
  Boxes,
  ArrowUpRight,
} from "lucide-react";

const SERVICES = [
  {
    icon: Ship,
    title: "Avitaillement maritime",
    desc: "Approvisionnement des navires en vivres et matériels essentiels.",
    span: "md:col-span-2",
  },
  {
    icon: Package,
    title: "Vente de produits vivriers",
    desc: "Achat et vente de produits alimentaires de qualité.",
  },
  {
    icon: Truck,
    title: "Livraison de vivres",
    desc: "Livraison rapide et sécurisée à destination.",
  },
  {
    icon: HardHat,
    title: "Matériels & Équipements",
    desc: "Commerce et fourniture de matériels divers pour vos opérations.",
  },
  {
    icon: Globe2,
    title: "Import – Export",
    desc: "Commerce international et solutions logistiques globales.",
    span: "md:col-span-2",
  },
  {
    icon: Laptop,
    title: "E-commerce & Commerce général",
    desc: "Services commerciaux digitaux et opérations de vente.",
  },
  {
    icon: Anchor,
    title: "Approvisionnement maritime",
    desc: "Services dédiés aux personnels navigants et aux navires.",
  },
  {
    icon: Boxes,
    title: "Habillage de conteneurs",
    desc: "Fourniture complète de matériels d'habillage de conteneurs.",
    span: "md:col-span-2",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-[#F9FAFB] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <div className="kms-overline mb-4 flex items-center gap-4">
              <span className="font-heading font-black text-sm text-[#D90429]">02</span>
              <span className="h-px w-12 bg-[#D90429]" />
              <span>Nos services</span>
            </div>
            <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter text-[#0A1128] leading-[1.05]">
              Des solutions complètes pour le{" "}
              <span className="text-[#D90429]">monde maritime</span> et le
              commerce.
            </h2>
          </div>
          <p className="text-[#6B7280] max-w-md text-base">
            Huit lignes de service conçues pour accompagner navires, entreprises
            et partenaires avec rigueur et réactivité.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className={`service-card ${s.span || "md:col-span-2"} min-h-[260px] flex flex-col justify-between`}
              >
                <div>
                  <div className="service-icon-box">
                    <Icon size={26} strokeWidth={1.6} />
                  </div>
                  <h3 className="font-heading font-bold text-xl sm:text-2xl mt-6 text-[#0A1128] tracking-tight leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm text-[#6B7280] leading-relaxed">
                    {s.desc}
                  </p>
                </div>
                <div className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#0A1128]">
                  En savoir plus <ArrowUpRight size={14} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
